'use es6';

import { FINDER_ASSET_TOGGLE_RENAME, FINDER_FILE_RENAME_CONFIRM_HIDE, FINDER_FOLDER_RENAME_CONFIRM_HIDE, FINDER_OPTIONS_FETCH, FINDER_OPTIONS_SAVE } from 'DesignData/actions/ActionTypes';
import * as client from 'DesignData/api/finder/Options';
import * as finderSelectors from 'DesignData/selectors/finder';
import { getPortalId, getUserId } from 'DesignData/selectors/auth';
import { createAsyncActions } from 'DesignData/lib/actions';
const getAsyncActions = createAsyncActions.bind(null, 'options');
/**
 * Fetch persisted finder options
 */

export function fetch() {
  const {
    request,
    receive,
    error
  } = fetch;
  return (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    dispatch(request());
    return client.fetch(userId, portalId).then(options => dispatch(receive(options))).catch(err => dispatch(error(err)));
  };
}
Object.assign(fetch, getAsyncActions(FINDER_OPTIONS_FETCH));
/**
 * Save finder options.
 */

export function save() {
  const {
    request,
    receive,
    error
  } = save;
  return (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    const options = finderSelectors.getSavedOptions(state);
    dispatch(request());
    return client.save(userId, portalId, options).then(savedOptions => dispatch(receive(savedOptions))).catch(err => dispatch(error(err)));
  };
}
Object.assign(save, getAsyncActions(FINDER_OPTIONS_SAVE));
/**
 * Toggle rename active state.
 * @param  {Number} assetId   ID of asset to rename.
 */

export function toggleRenameAsset(assetId, isDuplicate = false) {
  return {
    type: FINDER_ASSET_TOGGLE_RENAME,
    assetId,
    isDuplicate
  };
}
/**
 * Hide file rename confirm.
 */

export function hideRenameFileConfirm() {
  return {
    type: FINDER_FILE_RENAME_CONFIRM_HIDE
  };
}
/**
 * Hide folder rename confirm.
 */

export function hideRenameFolderConfirm() {
  return {
    type: FINDER_FOLDER_RENAME_CONFIRM_HIDE
  };
}